import { lazy } from "react";
import Loadable from "app/components/Loadable";

const SaasAutopayOpsPage = Loadable(lazy(() => import("./SaasAutopayOpsPage")));

const SaasAutopayOpsRoutes = [
  {
    path: "/admin/saas-subscriptions/ops",
    element: <SaasAutopayOpsPage />,
  },
];

export default SaasAutopayOpsRoutes;
